@if (data !== null) {
  <div
    [class.mode-iframe]="data.contentIframeUrl !== undefined"
    class="main"
    >
    @if (data.debug !== undefined || data.close !== undefined) {
      <div
        class="debug"
        >
        @if (data.debug !== undefined) {
          <mat-icon
            (click)="debugClick()"
            >bug_report
          </mat-icon>
        }
        @if (data.close !== undefined) {
          <mat-icon
            (click)="close()"
            >close
          </mat-icon>
        }
      </div>
    }
    @if (data.title !== undefined) {
      <h2
        mat-dialog-title
        >
        {{ data.title }}
      </h2>
    }
    <mat-dialog-content>
      @if (data.contentIframeUrl !== undefined) {
        <iframe
          [src]="data.contentIframeUrl|sanitizeUrl"
        ></iframe>
      }
      @if (data.content !== undefined) {
        <div
          [innerHTML]="data.content|sanitizeHtml"
          class="content"
        ></div>
      }
      @if (data.debugId !== undefined) {
        <div
          [innerHTML]="data.debugId|sanitizeHtml"
          class="debugId"
        ></div>
      }
      @if (data.contentLoader === true) {
        <div
          class="loader"
          >
          <mat-spinner
            color="primary"
            mode="indeterminate"
          ></mat-spinner>
        </div>
      }
      @if (data.contentIcon !== undefined) {
        <mat-icon
          class="icon"
          color="primary"
          >{{ data.contentIcon }}
        </mat-icon>
      }
    </mat-dialog-content>
    @if ((data.buttons?.length ?? 0) > 0) {
      <mat-dialog-actions
        [class.inline]="(data.buttons?.length ?? 0) <= 2"
        align="end"
        class="buttons"
        >
        @for (button of data.buttons; track button) {
          <button
            (click)="buttonClick(button)"
            class="button"
            mat-button
            >
            @if (button.iconLeft !== undefined) {
              <mat-icon
                class="icon-left"
                >
                {{ button.iconLeft }}
              </mat-icon>
            }
            {{ button.title }}
            @if (button.iconRight !== undefined) {
              <mat-icon
                class="icon-right"
                >
                {{ button.iconRight }}
              </mat-icon>
            }
          </button>
        }
      </mat-dialog-actions>
    }
  </div>
}
